import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {
        clientId: "c4aff752-074e-4c4a-83f1-3a5198b69c6a",
        authority: "https://login.microsoftonline.com/a0a46937-31e4-412c-b615-685e98f38d0d",
        redirectUri: "/",
        postLogoutRedirectUri: "/"
    },
    system: {
        allowNativeBroker: false // Disables WAM Broker
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
// Add here the endpoints for MS Graph API services you would like to use.
export const graphGroupConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me/memberOf"
};

